module.exports = __webpack_public_path__ + "static/media/IMG_8014.bff35b67.jpg";